<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="left-container">
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Code</mat-label>
                        <input matInput data-input-code type="text" formControlName="code" autocomplete="off" required />
                        @if (formGroupErrors?.code?.required && (formGroup.controls['code']?.dirty || formGroup.controls['code'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Code' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Code" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Nom</mat-label>
                        <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                        @if (formGroupErrors?.name?.required && (formGroup.controls['name']?.dirty || formGroup.controls['name'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Nom' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Nom" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Adresse 1</mat-label>
                        <input matInput data-input-address1 type="text" formControlName="address1" autocomplete="off" required />
                        @if (formGroupErrors?.address1?.required && (formGroup.controls['address1']?.dirty || formGroup.controls['address1'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Adresse 1' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Adresse 1" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Address2</mat-label>
                        <input matInput data-input-address2 type="text" formControlName="address2" autocomplete="off" />
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Adresse 2" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Code Postal</mat-label>
                        <input matInput data-input-postalCode type="text" formControlName="postalCode" autocomplete="off" required />
                        @if (formGroupErrors?.postalCode?.required && (formGroup.controls['postalCode']?.dirty || formGroup.controls['postalCode'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Code Postal' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Code postal" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Ville</mat-label>
                        <input matInput data-input-city type="text" formControlName="city" autocomplete="off" required />
                        @if (formGroupErrors?.city?.required && (formGroup.controls['city']?.dirty || formGroup.controls['city'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Ville' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Ville" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Pays</mat-label>
                        <input matInput data-input-country type="text" formControlName="country" autocomplete="off" required />
                        @if (formGroupErrors?.country?.required && (formGroup.controls['country']?.dirty || formGroup.controls['country'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Pays' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Pays" matTooltipPosition="right"></fa-icon>
                </div>
            </div>
            <div class="right-container">
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Siret</mat-label>
                        <input matInput data-input-siret type="text" formControlName="siret" autocomplete="off" />
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Siret" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Téléphone</mat-label>
                        <input matInput data-input-phoneNumber type="text" formControlName="phoneNumber" autocomplete="off" />
                        @if (formGroupErrors?.phoneNumber?.pattern && (formGroup.controls['phoneNumber']?.dirty || formGroup.controls['phoneNumber'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Téléphone' est incorrect</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Téléphone" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Mobile</mat-label>
                        <input matInput data-input-mobileNumber type="text" formControlName="mobileNumber" autocomplete="off" />
                        @if (formGroupErrors?.mobileNumber?.pattern && (formGroup.controls['mobileNumber']?.dirty || formGroup.controls['mobileNumber'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Mobile' est incorrect</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Mobile" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Fax</mat-label>
                        <input matInput data-input-faxNumber type="text" formControlName="faxNumber" autocomplete="off" />
                        @if (formGroupErrors?.faxNumber?.pattern && (formGroup.controls['faxNumber']?.dirty || formGroup.controls['faxNumber'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Fax' est incorrect</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Fax" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Email</mat-label>
                        <input matInput data-input-email type="text" formControlName="email" autocomplete="off" required />
                        @if (formGroupErrors?.email?.required && (formGroup.controls['email']?.dirty || formGroup.controls['email'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Email' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Email" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Csid</mat-label>
                        <input matInput data-input-csid type="text" formControlName="csid" autocomplete="off" />
                        @if (formGroupErrors?.csid?.pattern && (formGroup.controls['csid']?.dirty || formGroup.controls['csid'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Csid' est incorrect</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Csid" matTooltipPosition="right"></fa-icon>
                </div>

                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Type</mat-label>
                        <mat-select data-select-type formControlName="type" required>
                            @for (type of customerType; track type) {
                                <mat-option data-select-listing-type-option [value]="type.id">{{ type.value }}</mat-option>
                            }
                        </mat-select>
                        @if (formGroupErrors?.type?.required && (formGroup.controls['type']?.dirty || formGroup.controls['type'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Type' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Type" matTooltipPosition="right"></fa-icon>
                </div>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
